import "./packages.css";

import groupImg from "../../../Assets/Images/home/p-1.png";
import indivImg from "../../../Assets/Images/home/p-2.png";
import teamImg from "../../../Assets/Images/home/p-3.png";
import unlimitedImg from "../../../Assets/Images/home/p-3.png";
import { useInstructions } from "../../../APIContext/InstructionsContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Packages = () => {
  const { packages, fetchGroupInstructions } = useInstructions();
  const navigate = useNavigate();

  // console.log(fetchGroupInstructions)
  useEffect(() => {
    fetchGroupInstructions();
  }, []);

  const getNavigationFn = (id, pid) => {
    if (id === 0) {
      window.location.href = `/group-instruction?id=${pid}`;
    } else if (id === 1) {
      window.location.href = `/individual-instruction?id=${pid}`;
    } else if (id === 2) {
      window.location.href = `/unlimited-instruction?id=${pid}`;
    } else if (id === 3) {
      window.location.href = `/team-workout?id=${pid}`;
    }
  };

  return (
    <div style={{ "--br-value": 1.28 }} className="bg-custom brightness">
      <section className="instruction-packages-section">
        <div className="container">
          <h2 className="packages-title">OUR MOST POPULAR PACKAGES</h2>

          <div className="packages-grid">
            {packages
              .filter((item) => item.display_order !== 3)
              .map((item) => (
                <div key={item.id} className="package-card bg-custom">
                  <div style={{ minHeight: "205px" }}>
                    <h3 className="text-clip">{item.name}</h3>

                    <div className="list-item">
                      {item.points?.map((i) => (
                        <div>
                          <i className="ri-verified-badge-line text-clip"></i>
                          <p className="text-clip">{i}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <button
                    onClick={() => getNavigationFn(item.display_order, item.id)}
                  >
                    <span className="text-clip">Select Package</span>
                  </button>
                  <div className="package-img">
                    <img src={item.image} alt="Group Instruction" />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Packages;
